// extracted by mini-css-extract-plugin
export default {"container":"Work_container__advuo","main":"Work_main__VmC1n","header":"Work_header__LlyfI"};